import { v4 as uuidV4, v5 as uuidV5 } from 'uuid'

const createEntityId = (data: any) => uuidV5(
    JSON.stringify(data),
    uuidV4(),
)

export default createEntityId
